import { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { MenuCategoryOptionsQuerySchema, SearchScopeSchema } from '~/services/api/generated'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

const schema = MenuCategoryOptionsQuerySchema

const normalize = fieldNormalizer({
  enums: [{ field: 'search_scope', options: SearchScopeSchema.options }]
})

// Mirrors MenuCategoryMenuOptionsRequest::prepareForValidation.
export const MenuCategoryOptions = (_context: NoContext): z.ZodType<z.output<typeof schema>> =>
  z.preprocess(normalize, schema)
